import { BaseRouteService } from 'core/services';

class FulfillmentOrderImageRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'fulfillment-order-image/';
	}

	getImages(fulfillmentOrderId) {
		return this.uriTemplateService.parse(this.base + 'get/{fulfillmentOrderId}').expand({ fulfillmentOrderId });
	}
}

export default FulfillmentOrderImageRouteService;
